import React from 'react'

const PaycodeCombinations = () => {
    return (
        <>PaycodeCombinations mobile</>
    )
}

export { PaycodeCombinations }